import { render, staticRenderFns } from "./SanityVimeoSerializer.vue?vue&type=template&id=b8d01f72&scoped=true&"
import script from "./SanityVimeoSerializer.vue?vue&type=script&lang=ts&"
export * from "./SanityVimeoSerializer.vue?vue&type=script&lang=ts&"
import style0 from "./SanityVimeoSerializer.vue?vue&type=style&index=0&id=b8d01f72&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8d01f72",
  null
  
)

export default component.exports